module.exports = __webpack_public_path__ + "static/media/payment-img-free.ff35498c.jpg";